/**
 * Top-level `dashboards` folders that only an INTERNAL Canopy admin can see.
 *
 * A session that is not an internal admin (see `isInternalAdmin` in
 * `apps/api/src/auth/scope.ts`) cannot list, open, or mint grants against a
 * board in one of these folders or in any of their subfolders. The API
 * enforces this (`INTERNAL_ADMIN_ONLY_FOLDER_IDS_SQL`), and the web client
 * hides the same folders (`EmbedInsightsView`), so both read this one list.
 *
 * - `Analytics` (CSAGE-450): the Sisense-replacement estate, internal until GA.
 * - `Templates` (CSAGE-513): template boards. No customer owns them, and some
 *   (for example "Users & roles (template)") list data of every customer.
 *
 * Names match the top-level folder name without regard to case. To gate
 * another top-level folder, add its name here.
 */
export const INTERNAL_ADMIN_ONLY_FOLDER_NAMES = ['Analytics', 'Templates'];
/** True when `name` is one of `INTERNAL_ADMIN_ONLY_FOLDER_NAMES` (case-insensitive). */
export function isInternalAdminOnlyFolderName(name) {
    const n = name.toLowerCase();
    return INTERNAL_ADMIN_ONLY_FOLDER_NAMES.some((g) => g.toLowerCase() === n);
}
//# sourceMappingURL=folders.js.map